import {
  FaHtml5,
  FaCss3,
  FaNodeJs,
  FaReact,
  FaSass,
  FaPhoneAlt,
  FaUser,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaLinkedin,
  FaGithub,
  FaFacebook,
  FaTwitter,
} from "react-icons/fa";
import { DiJavascript } from "react-icons/di";
import { SiFirebase, SiMongodb, SiFiverr } from "react-icons/si";
import { BsMedium } from "react-icons/bs";

import work1 from "./assets/first.png";
import work2 from "./assets/second.png";
import work3 from "./assets/third.png";
import work4 from "./assets/fourth.png";
import work5 from "./assets/fifth.png";
import work6 from "./assets/sixth.png";
import work7 from "./assets/seven.png";
import work8 from "./assets/eight.png";
import work9 from "./assets/nine.png";
import work10 from "./assets/ten.png";
import work11 from "./assets/eleven.png";
import work12 from "./assets/twelve.png";
import work13 from "./assets/thirteen.png";
import work14 from "./assets/fourteen.png";
export const navLinks = ["home", "about", "skills", "portfolio", "contact"];

export const socialIcons = [
  <FaGithub />,
  <FaLinkedin />,
  <FaFacebook />,
  <FaTwitter />,
  <SiFiverr />,
];
export const links = [
  "https://github.com/rifaturrana",
  "https://www.linkedin.com/in/rifatur-rana-bba7091ab/",
  "https://www.facebook.com/rifatur.rana.1",
  "https://twitter.com/rana_rifatur",

  "https://www.fiverr.com/ui_catalyst/",
];

export const bios = [
  {
    id: 1,
    icon: <FaUser />,
    key: "Name",
    value: "S.M. Rifatur Rana",
  },
  {
    id: 2,
    icon: <FaPhoneAlt />,
    key: "Phone",
    value: "+8801865284103",
  },
  {
    id: 3,
    icon: <FaPaperPlane />,
    key: "Email",
    value: "smrifaturrana@gmail.com",
  },
];

export const icons = [
  <FaHtml5 />,
  <FaCss3 />,
  <FaSass />,
  <DiJavascript />,
  <FaReact />,
  <FaNodeJs />,
  <SiFirebase />,
  <SiMongodb />,
];

export const experiences = [
  {
    id: 1,
    year: "2023",
    position: "React Developer Intern",
    company: "Tork Inc.",
  },
  {
    id: 2,
    year: "2021",
    position: "Software Developer Trainee",
    company: "Diligite",
  },
  
];

export const workImages = [
  {
    id: 1,
    img: work8,
    name: "project 1",
    category: "React",
    live: "https://linkedin-clone-6b544.web.app/",
    github: "https://github.com/rifaturrana/linkedin-clone",
    title: "Linkedin Clone",
  },
  {
    id: 2,
    img: work9,
    name: "project 2",
    category: "React",
    live: "https://weatherapppwarana.netlify.app/",
    github: "https://github.com/rifaturrana/weather-pwa",
    title: "Weather App",
  },

  {
    id: 3,
    img: work12,
    name: "project 3",
    category: "React",
    live: "https://bookdoctoronline.herokuapp.com/",
    github: "https://github.com/rifaturrana/doctorsapp",
    title: "Book Doctor Online",
  },
  {
    id: 4,
    img: work13,
    name: "project 4",
    category: "React",
    live: "https://chat-omega.herokuapp.com/",
    github: "https://github.com/rifaturrana/LiveChatBox",
    title: "Chat App",
  },
  {
    id: 5,
    img: work14,
    name: "project 5",
    category: "React",
    live: "https://github.com/rifaturrana/ema-jon",
    github: "https://github.com/rifaturrana/ema-jon",
    title: "Ema Jon",
  },
  {
    id: 6,
    img: work11,
    name: "project 6",
    category: "React",
    live: "https://github.com/rifaturrana/simple_social_app",
    github: "https://github.com/rifaturrana/simple_social_app",
    title: "Simple Social App",
  },
  {
    id: 7,
    img: work7,
    name: "project 7",
    category: "JavaScript/DOM",
    live: "https://dicegamedombyrt.netlify.app/",
    github: "https://github.com/rifaturrana/Dice_Game_Dom",
    title: "Dice Game",
  },
  {
    id: 8,
    img: work10,
    name: "project 8",
    category: "JavaScript/DOM",
    live: "https://poromodotimer.netlify.app/",
    github: "https://github.com/rifaturrana/pomodoro_timer",
    title: "Pomodoro Timer",
  },
  {
    id: 9,
    img: work5,
    name: "project 9",
    category: "Design",
    live: "https://cssfinal.netlify.app/",
    github: "https://github.com/rifaturrana/bookmark-responsive-design",
    title: "Responsive Design",
  },
  {
    id: 10,
    img: work6,
    name: "project 10",
    category: "design",
    live: "https://sunglass-swag.netlify.app/",
    github: "https://github.com/rifaturrana/SunglassSwag",
    title: "Sunglass Swag",
  },

  {
    id: 11,
    img: work2,
    name: "project 11",
    category: "Design",
    live: "https://github.com/rifaturrana/ICTasksCSS",
    github: "https://github.com/rifaturrana/ICTasksCSS",
    title: "Watch Shop",
  },
  {
    id: 12,
    img: work3,
    name: "project 12",
    category: "Design",
    live: "https://github.com/rifaturrana/ICTasksCSS",
    github: "https://github.com/rifaturrana/ICTasksCSS",
    title: "Coffee Shop",
  },
  {
    id: 13,
    img: work4,
    name: "project 13",
    category: "Design",
    live: "https://github.com/rifaturrana/ICTasksCSS",
    github: "https://github.com/rifaturrana/ICTasksCSS",
    title: "Food Shop  Page",
  },

  {
    id: 14,
    img: work1,
    name: "project 14",
    category: "Design",
    live: "https://github.com/rifaturrana/ICTasksCSS",
    github: "https://github.com/rifaturrana/ICTasksCSS",
    title: "Ecommerce Banner",
  },
];

export const workNavs = ["All", "React", "JavaScript/DOM", "Design"];

export const contacts = [
  {
    id: 1,
    icon: <FaMapMarkerAlt />,
    infoText: "Lalbagh, Dhaka, Bangladesh",
  },
  {
    id: 2,
    icon: <FaPaperPlane />,
    infoText: "smrifaturrana@gmail.com",
  },
  {
    id: 3,
    icon: <FaPhoneAlt />,
    infoText: "+8801865284103",
  },
];
